import Phaser from 'phaser';
import { gameState } from '../game.js';
import { UIManager } from '../managers/UIManager.js';

export class SettingScene extends Phaser.Scene {
    constructor() {
        super({ key: 'SettingScene' });
        
        // UIコンポーネント
        this.resetButton = null;
        this.backButton = null;
        this.titleText = null;
        
        // 背景
        this.brickBackground = null;
        
        // UIマネージャー
        this.uiManager = null;
    }

    create() {
        console.log('SettingScene: Create function called');
        
        // UIマネージャーの初期化
        this.uiManager = new UIManager(this);
        
        // デスクトップの場合のみカーソルをポインタに
        if (!this.game.device.input.touch) {
            this.input.setDefaultCursor('pointer');
        }
        
        // 背景色の設定
        this.cameras.main.setBackgroundColor('#87CEEB');
        
        // レンガの背景を作成
        this.createBrickBackground();
        
        // タイトルテキスト
        this.createTitleText();
        
        // ハイスコアリセットボタン
        this.createResetButton();
        
        // サウンドテストボタン
        this.createSoundTestButton();
        
        // 戻るボタン
        this.createBackButton();
        
        // リビジョン情報の表示
        this.uiManager.createRevisionText();
        
        console.log('SettingScene: Create function completed');
    }
    
    /**
     * レンガの背景を作成する
     */
    createBrickBackground() {
        // 画面サイズを取得
        const width = this.game.config.width;
        const height = this.game.config.height;
        
        // TileSpriteとして背景を作成（画面より大きめに）
        this.brickBackground = this.add.tileSprite(
            width / 2,    // x位置（中央）
            height / 2,   // y位置（中央）
            width + 100,  // 幅（画面より少し大きく）
            height + 100, // 高さ（画面より少し大きく）
            'brick'       // テクスチャキー
        );
        
        // 背景を最背面に配置
        this.brickBackground.setDepth(-100);
        
        // 背景のスライドアニメーション
        this.tweens.add({
            targets: this.brickBackground,
            tilePositionX: { from: 0, to: 100 },
            tilePositionY: { from: 0, to: 100 },
            ease: 'Linear',
            duration: 20000,
            repeat: -1
        });
    }
    
    /**
     * タイトルテキストを作成する
     */
    createTitleText() {
        this.titleText = this.add.text(
            this.game.config.width / 2,
            this.game.config.height / 4,
            'SETTINGS',
            {
                fontSize: '48px',
                fontStyle: 'bold',
                fontFamily: 'DotGothic16',
                fill: '#ffffff',
                stroke: '#000000',
                strokeThickness: 6
            }
        );
        this.titleText.setOrigin(0.5);
        
        // タイトルのアニメーション
        this.tweens.add({
            targets: this.titleText,
            y: this.titleText.y - 10,
            duration: 1500,
            ease: 'Sine.easeInOut',
            yoyo: true,
            repeat: -1
        });
    }
    
    /**
     * ハイスコアリセットボタンを作成する
     */
    createResetButton() {
        this.resetButton = this.uiManager.createButton(
            this.game.config.height / 2 + 30,
            'RESET HIGH SCORE',
            {
                backgroundColor: '#f44336',
                hoverColor: '#d32f2f',
                fontSize: '42px'
            },
            () => {
                // ハイスコアリセット処理
                this.resetHighScore();
                
                // 確認メッセージを表示
                this.showResetConfirmation();
            }
        );
    }

    /**
     * サウンドテストボタンを作成する
     */
    createSoundTestButton() {
        this.soundTestButton = this.uiManager.createButton(
            this.game.config.height / 2 + 150, // 間隔を広げる
            'SOUND TEST',
            {
                backgroundColor: '#9C27B0',
                hoverColor: '#7B1FA2',
                fontSize: '42px'
            },
            () => {
                // SoundTestSceneに遷移
                this.scene.start('SoundTestScene');
            }
        );
    }
    
    /**
     * 戻るボタンを作成する
     */
    createBackButton() {
        this.backButton = this.uiManager.createButton(
            this.game.config.height / 2 + 270, // 間隔を広げる
            'BACK TO TITLE',
            {
                backgroundColor: '#2196F3',
                hoverColor: '#1976D2',
                fontSize: '42px'
            },
            () => {
                // TitleSceneに遷移
                this.scene.start('TitleScene');
            }
        );
    }
    
    /**
     * ハイスコアをリセットする
     */
    resetHighScore() {
        // localStorageからハイスコアを削除
        localStorage.removeItem('rubberBandGameHighScore');
        localStorage.removeItem('rubberBandGameEvaluationCounts');
        
        // gameStateのハイスコアと評価カウントをリセット
        gameState.highScore = 0;
        Object.keys(gameState.playState.evaluationCounts).forEach(key => {
            gameState.playState.evaluationCounts[key] = 0;
        });
        
        console.log('ハイスコアをリセットしました');
    }
    
    /**
     * リセット確認メッセージを表示する
     */
    showResetConfirmation() {
        // 確認メッセージを表示
        const confirmText = this.add.text(
            this.game.config.width / 2,
            this.game.config.height / 2,
            'HIGH SCORE RESET COMPLETE',
            {
                fontSize: '32px',
                fontFamily: 'DotGothic16',
                fill: '#ffffff',
                backgroundColor: '#000000',
                padding: { x: 20, y: 10 }
            }
        );
        confirmText.setOrigin(0.5);
        confirmText.setDepth(100);
        
        // 一定時間後に消える
        this.time.delayedCall(2000, () => {
            this.tweens.add({
                targets: confirmText,
                alpha: 0,
                duration: 500,
                onComplete: () => {
                    confirmText.destroy();
                }
            });
        });
    }
    
    update() {
        // 必要に応じて更新処理を追加
    }
}
